<template>
  <div>
    <div
      id="EditButtons"
      class="mt-3 text-right animate__animated animate__fadeInDown"
    >
      <button
        id="EditData"
        class="btn btn-Orange mr-1"
        dir="ltr"
        @click.prevent="
          EditDeta();
          $ResetTimer();
        "
      >
        <span class="mr-2"> ثبت اصلاحات</span>
        <span class="fa fa fa-check"></span>
      </button>
      <button
        v-if="this.$route.name == 'TarifSematha'"
        id="btn-Cancel"
        data-dismiss="modal"
        class="btn btn-danger mr-1"
        dir="ltr"
      >
        <span class="mr-2">انصراف</span> <span class="fa fa-reply"></span>
      </button>
      <span v-else>
        <button
          v-if="IsBtnBack"
          id="btnCancel"
          class="btn btn-danger mr-1"
          dir="ltr"
          @click.prevent="
            Back();
            $ResetTimer();
          "
        >
          <span class="mr-2">بازگشت</span> <span class="fa fa-reply"></span>
        </button>
      </span>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      IsBtnBack: true,
      DataAxiosUpdate: {
        ArryfildValue: {},
        Method: "put",
        Action: "",
        Token: this.$session.get("Token"),
        From: "Body",
      },
      DataAddLogInformation: {
        ArryfildValue: {},
        Method: "post",
        Action: "UserLogInformation/b_AddRow",
        Token: this.$session.get("Token"),
      },
    };
  },
  mounted() {
    if (this.IsButtonBack == false) this.IsBtnBack = false;
    else this.IsBtnBack = true;
  },
  methods: {
    Back() {
      this.$router.go(-1);
    },
    EditDeta: function () {
      console.log("data", this.DataParanet);
      if (this.$ValidForm(this.$route.name)) {
        this.$SetLog(this.DataParanet, 0);
        if (this.$route.name.substring(0, 6) == "Detail") {
          console.log("edit data", this.DataAxiosUpdate);

          this.DataAxiosUpdate.ArryfildValue = this.DataParanet;
          console.log(this.DataAxiosUpdate);
          this.DataAxiosUpdate.Action = this.$route.name.substring(6);
          if (this.$route.name == "DetailDefineShobe") {
            const formData = new FormData();
            const object = this.$store.state.DefineShobe.EditData[0];
            formData.append("file", object.imgLogoShobe);
            formData.append("Id", object.ImgLogoShobeId);
            if (object.ImgLogoShobeId == 0 || object.ImgLogoShobeId == null) {
              formData.append("ColName", "ImgLogoShobeId");
              formData.append("UseTableName", "tblShobe");
              formData.append(
                "TblUserGrpId",
                this.$session.get("UserInfo").tblUserGrpId
              );

              this.DataAxiosUpdate.Action = "UploadImg";
              this.DataAxiosUpdate.Method = "Post";
              this.DataAxiosUpdate.ArryfildValue = formData;
              this.$PutFormData(this.DataAxiosUpdate).then((data) => {
                if (data.status == "OK") {
                  this.DataParanet.ImgLogoShobeId = data.imageId;
                } else if (data.status == "noImage") {
                  this.DataParanet.ImgLogoShobeId = 0;
                }
                this.DataParanet.imgLogoShobe = null;
                this.DataAxiosUpdate.ArryfildValue = this.DataParanet;
                this.DataAxiosUpdate.Method = "Put";
                this.DataAxiosUpdate.Action = this.$route.name.substring(6);
                this.$PutData_Body(this.DataAxiosUpdate)
                  .then((data) => {
                    if (data.status == "Ok") {
                      this.$mySweetDefaultTost(
                        false,
                        "بارگزاری اطلاعات موفقیت آمیز بود",
                        "success",
                        1000
                      );
                      document.getElementById("btnCancel").click();
                    } else {
                      if (data.eNum == "2601") {
                        this.$mySweetDefaultTost(
                          false,
                          "امکان ثبت داده تکراری وجود ندارد. ورودی های خود را کنترل کنید ",
                          "error",
                          3000
                        );
                      } else {
                        // this.$SweetQustion(
                        //   "خطایی رخ داده!",
                        //   "در ثبت اطلاعات خطایی رخ داده لطفا با پشتیبانی تماس بگیرید (" + data + ")",'جزئیات','بستن',data.msg,this.details,this.cancel);
                        this.$SweetQustion(
                          "خطایی رخ داده است",
                          "در ثبت اطلاعات خطایی رخ داده است، با پشتیبانی تماس بگیرید",
                          "warning",
                          "جزئیات",
                          "بستن",
                          data.msg,
                          this.details,
                          this.CancelEdit
                        );
                      }
                      //  this.$mySweetDefaultTost(false, 'اطلاعات خود را دوباره بررسی کنید.امکان انجام تغییرات وجود ندارد.', 'error', 3000);
                    }
                  })
                  .finally(() => {
                    // this.$SweetQustion('ویرایش موفق',"اطلاعات با موفقیت بروز رسانی شد",'success','ثبت جدید','بستن صفحه',null,this.SetNew,this.Cancel);
                    this.$store.state.renderComponentGrid = false;
                    this.$store.state.renderComponent = false;
                    this.$store.state.renderComponentTree = false;
                    this.$nextTick(() => {
                      // Add the component back in
                      this.$store.state.renderComponentGrid = true;
                      this.$store.state.renderComponent = true;
                      this.$store.state.renderComponentTree = true;
                    });
                  });
              });
            } else {
              formData.append("ColName", "ImgLogoShobeId");
              formData.append("UseTableName", "tblShobe");
              console.log("here");
              this.DataAxiosUpdate.Action = "UploadImg/b_Update";
              this.DataAxiosUpdate.Method = "Post";
              this.DataAxiosUpdate.ArryfildValue = formData;
              this.$PutFormData(this.DataAxiosUpdate).then((data) => {
                if (data.status == "noImage") {
                  this.DataParanet.ImgLogoShobeId = 0;
                }
                this.DataParanet.imgLogoShobe = null;
                this.DataAxiosUpdate.ArryfildValue = this.DataParanet;
                this.DataAxiosUpdate.Method = "Put";
                this.DataAxiosUpdate.Action = this.$route.name.substring(6);
                console.log("******", this.DataParanet.ImgLogoShobeId);
                this.$PutData_Body(this.DataAxiosUpdate)
                  .then((data) => {
                    if (data.status == "Ok") {
                      this.$mySweetDefaultTost(
                        false,
                        "بارگزاری اطلاعات موفقیت آمیز بود",
                        "success",
                        1000
                      );
                      document.getElementById("btnCancel").click();

                      // this.$GetData_Body(this.DataAxiosUpdate).then((data)=>{
                      //   console.log(data);
                      // })
                    } else {
                      if (data.eNum == "2601") {
                        this.$mySweetDefaultTost(
                          false,
                          "امکان ثبت داده تکراری وجود ندارد. ورودی های خود را کنترل کنید ",
                          "error",
                          3000
                        );
                      } else {
                        // this.$SweetQustion(
                        //   "خطایی رخ داده!",
                        //   "در ثبت اطلاعات خطایی رخ داده لطفا با پشتیبانی تماس بگیرید (" + data + ")",'جزئیات','بستن',data.msg,this.details,this.cancel);
                        this.$SweetQustion(
                          "خطایی رخ داده است",
                          "در ثبت اطلاعات خطایی رخ داده است، با پشتیبانی تماس بگیرید",
                          "warning",
                          "جزئیات",
                          "بستن",
                          data.msg,
                          this.details,
                          this.CancelEdit
                        );
                      }
                      //  this.$mySweetDefaultTost(false, 'اطلاعات خود را دوباره بررسی کنید.امکان انجام تغییرات وجود ندارد.', 'error', 3000);
                    }
                  })
                  .finally(() => {
                    // this.$SweetQustion('ویرایش موفق',"اطلاعات با موفقیت بروز رسانی شد",'success','ثبت جدید','بستن صفحه',null,this.SetNew,this.Cancel);
                    this.$store.state.renderComponentGrid = false;
                    this.$store.state.renderComponent = false;
                    this.$store.state.renderComponentTree = false;
                    this.$nextTick(() => {
                      // Add the component back in
                      this.$store.state.renderComponentGrid = true;
                      this.$store.state.renderComponent = true;
                      this.$store.state.renderComponentTree = true;
                    });
                  });
              });
            }
          } else {
            //  console.log("Jadid",this.DataParanet.WebDbname);
            //  console.log("Ghadim",JSON.parse(this.$store.state.DefineInfoSystem.BeforEdit).WebDbname);
            this.$PutData_Body(this.DataAxiosUpdate)
              .then((data) => {
                if (data.status == "Ok") {
                  this.$mySweetDefaultTost(
                    false,
                    "بارگزاری اطلاعات موفقیت آمیز بود",
                    "success",
                    1000
                  );
                  document.getElementById("btnCancel").click();
                  //متد ثبت لاگ
                  // this.$SetLog(this.DataParanet,0);
                } else {
                  if (data.eNum == "2601") {
                    this.$mySweetDefaultTost(
                      false,
                      "امکان ثبت داده تکراری وجود ندارد. ورودی های خود را کنترل کنید ",
                      "error",
                      3000
                    );
                  } else if (data.eNum == "1010") {
                    this.$mySweetDefault("توجه ...", data.msg, "error", 3000);
                  } else {
                    // this.$SweetQustion(
                    //   "خطایی رخ داده!",
                    //   "در ثبت اطلاعات خطایی رخ داده لطفا با پشتیبانی تماس بگیرید (" + data + ")",'جزئیات','بستن',data.msg,this.details,this.cancel);
                    this.$SweetQustion(
                      "خطایی رخ داده است",
                      "در ثبت اطلاعات خطایی رخ داده است، با پشتیبانی تماس بگیرید",
                      "warning",
                      "جزئیات",
                      "بستن",
                      data.msg,
                      this.details,
                      this.CancelEdit
                    );
                  }
                  //  this.$mySweetDefaultTost(false, 'اطلاعات خود را دوباره بررسی کنید.امکان انجام تغییرات وجود ندارد.', 'error', 3000);
                }
              })
              .finally(() => {
                // this.$SweetQustion('ویرایش موفق',"اطلاعات با موفقیت بروز رسانی شد",'success','ثبت جدید','بستن صفحه',null,this.SetNew,this.Cancel);
                this.$store.state.renderComponentGrid = false;
                this.$store.state.renderComponent = false;
                this.$store.state.renderComponentTree = false;
                this.$nextTick(() => {
                  // Add the component back in
                  this.$store.state.renderComponentGrid = true;
                  this.$store.state.renderComponent = true;
                  this.$store.state.renderComponentTree = true;
                });
              });
          }
          // }
        } else {
          console.log("save data");
          if (this.RouteCustom) {
            //IS RoutCustom
            this.DataAxiosUpdate.Action = this.RouteCustom;
          } else {
            this.DataAxiosUpdate.Action = this.$route.name;
          }
          this.DataAxiosUpdate.ArryfildValue = this.DataParanet;
          var uploaders = document.getElementsByClassName("uploader");
          if (uploaders.length > 0) {
            uploaders.forEach((element) => {
              if (element.value != "") {
                var Datafield = element.id;
                const formData = new FormData();
                formData.append(
                  "TblUserGrpId",
                  this.$session.get("UserInfo").tblUserGrpId
                );
                formData.append("UseTableName", this.$route.name);
                formData.append("ColName", Datafield);
                formData.append("Image", this.$DataURIToBlob(element.value));
                var FormDataImg = { Action: "", ArryfildValue: "", Method: "" };
                FormDataImg.Action = "UploadImg/index";
                FormDataImg.ArryfildValue = formData;
                FormDataImg.Method = "POST";
                console.log("POst");
                this.$PostFormData(FormDataImg)
                  .then((data) => {
                    console.log("Loooog", data);
                    if (data.status == "OK") {
                      console.clear();
                      this.DataAxiosUpdate.ArryfildValue[Datafield] =
                        data.imageId;

                      console.log(element, element.Id);
                      console.log(
                        "iamgeIDDDD",
                        Datafield,
                        this.DataAxiosUpdate.ArryfildValue,
                        this.DataAxiosUpdate.ArryfildValue[Datafield],
                        data.imageId
                      );
                    } else {
                      this.$mySweetDefaultTost(
                        "خطا",
                        "خطا در بارگذاری فایل",
                        "error",
                        2000
                      );
                    }
                  })
                  .finally(() => {
                    this.Post();
                  });
              }
            });
            this.Post();
          } else {
            this.Post();
          }
        }
      }
    },
    Post() {
      this.$PutData_Body(this.DataAxiosUpdate)
        .then((data) => {
          if (data.status == "Ok") {
            this.$emit("Status", true);
            if (this.$route.name.substring(0, 6) == "Detail") {
              var x = this.$store.state[this.$route.name.substring(6)].Data[0];
            } else {
              x = this.$store.state[this.$route.name].Data[0];
            }

            this.$emit("emptysaved", x);
            this.$mySweetPost(
              "ثبت موفق",
              "اطلاعات با موفقیت ثبت شد",
              "success",
              "ثبت و ادامه",
              "بستن صفحه"
            );
            //#region ثبت رویداد های سیستم
            var object = this.$store.state.objectLogInformation;
            object.UserId = this.$session.get("UserInfo").tblUserId;
            object.UserNameFamily = this.$session.get("UserInfo").namFam;
            object.FormId = this.$route.name.substring(6);
            object.tblShobeId = this.$session.get("UserInfo").tblShobeId;
            object.FkId = data.returnId;
            object.IsDelete = 0;

            for (
              let index = 0;
              index < this.$session.get("Menu").length;
              index++
            ) {
              const element = this.$session.get("Menu")[index];
              if (element.RouteName == object.FormId) {
                object.FormName = element.label;
              }
            }
            this.$getLocalIP().then((res) => {
              object.IpAddress = res;
            });

            this.DataAddLogInformation.ArryfildValue = object;
            this.$PostData(this.DataAddLogInformation).then((datapost) => {
              console.log(datapost);
            });
            //#endregion  ثبت رویداد های سیستم
          } else {
            console.log("error", data);
            if (data.eNum == "2601") {
              this.$mySweetDefaultTost(
                "خطایی رخ داده!",
                "امکان ثبت داده تکراری وجود ندارد. ورودی های خود را کنترل کنید ",
                "error",
                3000
              );
            } else if (data.eNum == "1010") {
              this.$mySweetDefault("خطا ...", data.msg, "error", 3000);
            } else {
              this.$SweetQustion(
                "خطایی رخ داده است",
                "در ثبت اطلاعات خطایی رخ داده است، با پشتیبانی تماس بگیرید",
                "warning",
                "جزئیات",
                "بستن",
                data.msg,
                this.details,
                this.CancelEdit
              );
            }
          }
        })
        .finally(() => {});
    },
  },
  props: ["DataParanet", "RouteCustom", "IsButtonBack"],
};
</script>
<style scoped>
.btn {
  border-radius: 0px;
}

.btn-Orange {
  background-color: #ff9800;
}
</style>
